 <div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">rule</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Associar itens da NF-e</h2>
    <span class="modal-subtitle">Identifique o produto, a unidade e o lote/série de cada item</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="alternarTamanho()"
      [matTooltip]="isMaximizado ? 'Restaurar' : 'Maximizar'">
      <mat-icon class="material-symbols-outlined">{{ isMaximizado ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" matTooltip="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content associacao-conteudo">
  @if (isLoading) {
  <div class="d-flex flex-column gap-3 py-2">
    <app-loading-box height="56"></app-loading-box>
    <app-loading-box height="56"></app-loading-box>
    <app-loading-box height="56"></app-loading-box>
  </div>
  } @else if (isErroCarga) {
  <app-alert-card type="error" icon="cloud_off" title="Nota não carregada">
    Não foi possível carregar a nota e os itens. Nenhum dado foi alterado.
    <div alertActions>
      <button mat-stroked-button type="button" class="btn-secondary" (click)="carregar()">
        <mat-icon class="material-symbols-outlined">refresh</mat-icon>Tentar novamente
      </button>
    </div>
  </app-alert-card>
  } @else {

  <app-content-card tone="neutral" icon="receipt_long" [bordered]="false" class="associacao-nota">
    <div class="associacao-nota-dados">
      <div class="associacao-nota-identificacao">
      <div>
      <span class="associacao-nota-titulo">NF-e {{ numeroNota || '-' }}{{ serieNota ? '/' + serieNota : '' }}</span>
      @if (nomeFornecedor) {
      <span class="associacao-nota-fornecedor">{{ nomeFornecedor }}</span>
      }
      </div>
      <span class="status-badge" [ngClass]="classeBadgeStatus(nota?.idStatusNFeEntrada)">
        <mat-icon class="material-symbols-outlined">{{ iconeStatus(nota?.idStatusNFeEntrada) }}</mat-icon>{{ rotuloStatus(nota?.idStatusNFeEntrada) }}
      </span>
      @if (nota?.isCancelada) { <span class="status-badge badge-vermelho">Cancelada</span> }
      @if (nota?.isReaberta) { <span class="status-badge badge-azul">Reaberta</span> }
      </div>
      <div class="associacao-nota-campos">
        <div>
          <small>Emissão</small>
          <span>{{ dataEmissao ? (dataEmissao | datetimeEmpresa:'dd/MM/yyyy') : '-' }}</span>
        </div>
        <div>
          <small>Valor total</small>
          <span>{{ valorTotal | abnt: 'preco' : 2 }}</span>
        </div>
        @if (chaveAcesso) {
        <div>
          <small>Chave de acesso</small>
          <span class="associacao-nota-chave">{{ chaveAcesso }}</span>
        </div>
        }
      </div>
    </div>

    <div contentCardActions class="associacao-filtros" role="group" aria-label="Filtrar associações">
      <button type="button" class="associacao-filtro" [class.active]="filtro === filtroEnum.Todos"
        (click)="selecionarFiltro(filtroEnum.Todos)">Todos</button>
      <button type="button" class="associacao-filtro" [class.active]="filtro === filtroEnum.Pendentes"
        (click)="selecionarFiltro(filtroEnum.Pendentes)">Pendentes</button>
      <button type="button" class="associacao-filtro" [class.active]="filtro === filtroEnum.Associados"
        (click)="selecionarFiltro(filtroEnum.Associados)">Associados</button>
    </div>
  </app-content-card>

  <app-alert-card type="info">
    O lançamento da nota só pode ser confirmado com todos os itens associados. Conversões de unidade e controles de
    lote/série são aplicados na movimentação de estoque.
  </app-alert-card>

  @if (isErroCargaProdutos) {
  <app-alert-card type="error" icon="cloud_off" title="Produtos associados não carregados">
    O cadastro dos produtos já associados não respondeu. As associações gravadas continuam na nota; salvar e concluir ficam
    bloqueados até carregar.
    <div alertActions>
      <button mat-stroked-button type="button" class="btn-secondary" (click)="carregarProdutosAssociados()">
        <mat-icon class="material-symbols-outlined">refresh</mat-icon>Tentar novamente
      </button>
    </div>
  </app-alert-card>
  }

  @if (aprendizadoPendente) {
  <app-alert-card type="warning" icon="handshake" title="Associação salva">
    Não foi possível registrar o código do fornecedor no(s) item(ns) {{ textoItensAprendizadoPendente }}. A associação já está
    gravada; tente registrar de novo ou feche o modal.
  </app-alert-card>
  }

  @if (itens.length === 0) {
  <app-empty-state icon="inventory_2" title="Nenhum item na nota" subtitle="Não há itens para associar."></app-empty-state>
  } @else if (itensFiltrados.length === 0) {
  <app-empty-state icon="filter_alt_off" title="Nenhum item neste filtro"
    subtitle="Tente selecionar outro filtro para ver os itens desta nota."></app-empty-state>
  } @else {

  <div class="associacao-lista">
    @for (i of itensFiltrados; track i.item.idNFeEntradaItem ?? i.item.numeroItem) {
    <div class="associacao-card" [id]="'associacao-item-' + i.item.numeroItem"
      [class.associacao-card--resolvido]="isResolvido(i)"
      [class.associacao-card--destacado]="i.isDestacado">

      <div class="associacao-card-header" [class.associacao-card-header--aberto]="i.isExpandido" role="button" tabindex="0"
        [attr.aria-expanded]="i.isExpandido" (click)="toggleExpandido(i)" (keydown.enter)="toggleExpandido(i)">
        <mat-icon class="material-symbols-outlined associacao-card-destaque">box</mat-icon>
        <span class="associacao-card-numero associacao-card-destaque">ITEM #{{ i.item.numeroItem }}</span>
        @if (!i.isExpandido) {
        <span class="associacao-card-separador">·</span>
        <span class="associacao-card-resumo">{{ i.item.descricao }}</span>
        }
        <span class="associacao-card-espaco"></span>

        @if (i.isBuscandoSugestao) {
        <mat-spinner diameter="18" aria-label="Buscando correspondência"></mat-spinner>
        } @else if (exibirBadgeRegra(i)) {
        <span class="status-badge" [ngClass]="visualRegra(i).classe" [matTooltip]="visualRegra(i).tooltip">
          <mat-icon class="material-symbols-outlined">{{ visualRegra(i).icone }}</mat-icon>
          {{ visualRegra(i).rotulo }}
        </span>
        }
        @if (isResolvido(i)) {
        <span class="status-badge badge-verde">
          <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
          Associado
        </span>
        } @else {
        <span class="status-badge badge-amarelo" [matTooltip]="motivoPendencia(i)">
          <mat-icon class="material-symbols-outlined">pending_actions</mat-icon>
          Pendente
        </span>
        }
        <mat-icon class="material-symbols-outlined associacao-card-chevron"
          [matTooltip]="i.isExpandido ? 'Recolher item' : 'Expandir item'">{{ i.isExpandido ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>

      @if (i.isExpandido) {
      <div class="associacao-card-corpo">

        <div class="associacao-coluna">
          <span class="associacao-coluna-titulo">
            <mat-icon class="material-symbols-outlined">box</mat-icon>
            Item da nota
          </span>
          <span class="associacao-coluna-nome">{{ i.item.descricao }}</span>
          <span class="associacao-coluna-meta">{{ metaItem(i) }}</span>
          <span class="associacao-pilula-quantidade">
            {{ i.item.quantidadeComercial | abnt: 'quantidade' : casasQuantidade(i.item.quantidadeComercial) }} {{ i.item.unidadeComercial }} ·
            {{ i.item.valorUnitarioComercial | abnt: 'preco' : casasValorUnitario(i.item.valorUnitarioComercial) }}
          </span>
        </div>

        @if (!data.isSomenteLeitura) {
        <div class="associacao-painel-acoes">
          <span [matTooltip]="i.produto || i.agrupador ? 'Trocar produto' : 'Nenhum produto associado'">
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel"
              [disabled]="(!i.produto && !i.agrupador) || i.isAtualizandoCadastro" (click)="abrirBusca(i)">
              <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
              Trocar
            </button>
          </span>
          @if (i.estado !== estadoEnum.Associado) {
          <span [matTooltip]="podeConfirmar(i) ? 'Confirmar associação' : motivoNaoConfirma(i)">
            <button mat-flat-button type="button" class="btn-primary associacao-botao-painel"
              [disabled]="!podeConfirmar(i)" (click)="confirmarItem(i)">
              <mat-icon class="material-symbols-outlined">check</mat-icon>
              Confirmar
            </button>
          </span>
          }
        </div>
        }

        <div class="associacao-coluna associacao-coluna--produto">
          <span class="associacao-coluna-titulo">
            <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
            Produto do sistema
          </span>

          @if (i.produto) {
          <span class="associacao-coluna-nome associacao-texto-cortado">{{ i.produto.descricao }}</span>
          <span class="associacao-coluna-meta associacao-texto-cortado">{{ metaProduto(i.produto) }}</span>
          <div class="associacao-produto-controle">
            @if (exibirBadgeRegra(i)) { <span class="status-badge badge-cinza">{{ visualRegra(i).rotulo }}</span> }
            <span>{{ descricaoControle(i.produto) }}</span>
          </div>
          @if (isRegraDescricao(i)) {
          <app-alert-card type="warning" icon="rate_review">Relacionado apenas pela descrição - revise antes de associar.</app-alert-card>
          }
          } @else if (i.agrupador) {
          <span class="associacao-coluna-nome associacao-texto-cortado">{{ i.agrupador.descricao }}</span>
          <app-alert-card type="info" icon="style">Agrupador de variações - escolha abaixo o SKU que recebe a entrada.</app-alert-card>
          } @else if (!i.isBuscandoSugestao) {
          @if (i.isProdutoNaoEncontrado) {
          <app-alert-card type="error" icon="inventory_2">O produto associado não existe mais no cadastro. Escolha outro produto.</app-alert-card>
          } @else if (i.isErroSugestao) {
          <app-alert-card type="warning" icon="cloud_off">Não foi possível buscar a correspondência automática. Selecione o produto manualmente.</app-alert-card>
          }
          @if (!data.isSomenteLeitura) {
          <app-select-pesquisavel #produtoSelect [control]="i.produtoControl" label="Produto"
            idField="idProduto" nameField="descricao" [apiUrl]="urlProduto"
            [subtitleFields]="['codigoSku', 'unidade', 'ncm']" subscriptSizing="dynamic"
            [hasSuffixAction]="true" (selectionChange)="escolherProduto(i, $event)">
            <button spSuffix mat-icon-button type="button" class="icon-mat-symbols-btn btn-spinner" aria-label="Recarregar produtos"
              [class.btn-loading]="produtoSelect.isRecarregando" [disabled]="produtoSelect.isRecarregando"
              matTooltip="Recarregar produtos após cadastrar em outra aba" (click)="$event.stopPropagation(); produtoSelect.recarregar()">
              <mat-icon class="material-symbols-outlined">refresh</mat-icon>
              @if (produtoSelect.isRecarregando) { <mat-spinner diameter="18"></mat-spinner> }
            </button>
          </app-select-pesquisavel>
          <span [matTooltip]="i.item.idNFeEntradaItem ? 'Abrir cadastro de produto em outra aba' : 'Salve o item da nota antes de cadastrar um produto'">
            <button mat-stroked-button type="button" class="btn-secondary" [disabled]="!i.item.idNFeEntradaItem" (click)="cadastrarProduto(i)">
              <mat-icon class="material-symbols-outlined">add</mat-icon>Cadastrar produto
            </button>
          </span>
          }
          @if (!i.isProdutoNaoEncontrado && !i.isErroSugestao) {
          <app-alert-card type="warning" [icon]="i.isAssociacaoDesfeita ? 'link_off' : 'note_add'">
            {{ i.isAssociacaoDesfeita ? 'Associação desfeita - escolha um produto do cadastro ou cadastre um novo.' : 'Nenhuma regra encontrou produto no cadastro. Selecione um produto ou cadastre um novo.' }}
          </app-alert-card>
          }
          }
        </div>
      </div>

      @if (temFaixaInferior(i)) {
      <div class="associacao-faixa">

        @if (exibirDivergenciaNcm(i)) {
        <app-content-card title="NCM divergente" [tone]="i.decisaoNcm ? 'success' : 'warning'" [icon]="i.decisaoNcm ? 'check_circle' : 'warning'">
          <div class="associacao-divergencia-texto">
            Cadastro <span class="associacao-numero">{{ ncmCadastro(i) }}</span>, NF
            <span class="associacao-numero associacao-divergencia-valor">{{ i.item.codigoNcm }}</span>. Deseja atualizar o cadastro?
            @if (i.decisaoNcm) { <span class="associacao-divergencia-decisao"> · {{ i.decisaoNcm }}</span> }
          </div>
          @if (!i.decisaoNcm && !data.isSomenteLeitura) {
          <div contentCardActions class="associacao-divergencia-acoes">
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel" (click)="manterNcm(i)">Manter cadastro</button>
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel btn-spinner"
              [class.btn-loading]="i.operacaoCadastro === operacaoCadastroEnum.Ncm"
              aria-label="Atualizar NCM do cadastro" [disabled]="i.isAtualizandoCadastro" (click)="atualizarNcm(i)">
              <mat-icon class="material-symbols-outlined">sync</mat-icon>
              Atualizar cadastro
              @if (i.operacaoCadastro === operacaoCadastroEnum.Ncm) { <mat-spinner diameter="18"></mat-spinner> }
            </button>
          </div>
          }
        </app-content-card>
        }

        @if (situacaoEanExibida(i) !== null) {
        <app-content-card [title]="situacaoEanExibida(i) === situacaoEanEnum.Divergente ? 'EAN divergente' : 'EAN não cadastrado'" [tone]="i.decisaoEan ? 'success' : 'warning'" [icon]="i.decisaoEan ? 'check_circle' : 'warning'">
          <div class="associacao-divergencia-texto">
            @if (situacaoEanExibida(i) === situacaoEanEnum.Divergente) {
            Cadastro <span class="associacao-numero">{{ eanCadastro(i) }}</span>, NF
            <span class="associacao-numero associacao-divergencia-valor">{{ i.item.codigoEanComercial }}</span>. Deseja atualizar o cadastro?
            } @else {
            A NF traz o GTIN
            <span class="associacao-numero associacao-divergencia-valor">{{ i.item.codigoEanComercial }}</span>. Deseja adicionar este EAN ao produto?
            }
            @if (i.decisaoEan) { <span class="associacao-divergencia-decisao"> · {{ i.decisaoEan }}</span> }
          </div>
          @if (!i.decisaoEan && !data.isSomenteLeitura) {
          <div contentCardActions class="associacao-divergencia-acoes">
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel" (click)="ignorarEan(i)">
              {{ situacaoEanExibida(i) === situacaoEanEnum.Divergente ? 'Manter cadastro' : 'Ignorar' }}
            </button>
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel btn-spinner"
              [class.btn-loading]="i.operacaoCadastro === operacaoCadastroEnum.Ean"
              aria-label="Gravar EAN no cadastro" [disabled]="i.isAtualizandoCadastro" (click)="gravarEan(i)">
              <mat-icon class="material-symbols-outlined">{{ situacaoEanExibida(i) === situacaoEanEnum.Divergente ? 'sync' : 'add' }}</mat-icon>
              {{ situacaoEanExibida(i) === situacaoEanEnum.Divergente ? 'Atualizar cadastro' : 'Adicionar EAN' }}
              @if (i.operacaoCadastro === operacaoCadastroEnum.Ean) { <mat-spinner diameter="18"></mat-spinner> }
            </button>
          </div>
          }
        </app-content-card>
        }

        @if (isCodigoFornecedorNaoRegistrado(i)) {
        <app-content-card title="Código do fornecedor não registrado" [tone]="i.decisaoCodigo ? 'success' : 'warning'" [icon]="i.decisaoCodigo ? 'check_circle' : 'warning'">
          <div class="associacao-divergencia-texto">
            A NF traz o código
            <span class="associacao-numero associacao-divergencia-valor">{{ i.item.codigoProdutoEmitente }}</span> deste fornecedor,
            mas ele ainda não está associado a este produto no cadastro. Ele será registrado ao salvar, o que habilita a regra de
            prioridade por código do fornecedor nas próximas notas; escolha Ignorar para não registrar.
            @if (i.decisaoCodigo) { <span class="associacao-divergencia-decisao"> · {{ i.decisaoCodigo }}</span> }
          </div>
          @if (!i.decisaoCodigo && !data.isSomenteLeitura) {
          <div contentCardActions class="associacao-divergencia-acoes">
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel" (click)="ignorarCodigoFornecedor(i)">Ignorar</button>
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel btn-spinner"
              [class.btn-loading]="i.operacaoCadastro === operacaoCadastroEnum.CodigoFornecedor"
              aria-label="Registrar código do fornecedor" [disabled]="i.isAtualizandoCadastro" (click)="registrarCodigoFornecedor(i)">
              <mat-icon class="material-symbols-outlined">handshake</mat-icon>
              Registrar código
              @if (i.operacaoCadastro === operacaoCadastroEnum.CodigoFornecedor) { <mat-spinner diameter="18"></mat-spinner> }
            </button>
          </div>
          }
        </app-content-card>
        }

        @if (i.agrupador) {
        <div class="associacao-variacao">
          <div class="associacao-variacao-titulo">
            <mat-icon class="material-symbols-outlined">style</mat-icon>
            Produto é um agrupador de variações
          </div>
          <span class="associacao-variacao-descricao">
            Selecione a variação (SKU filho) que recebe a entrada de
            {{ quantidadeEstoque(i) | abnt: 'quantidade' }} {{ i.item.unidadeComercial }}.
          </span>
          @if (i.isCarregandoFilhos) {
          <app-loading-box height="36"></app-loading-box>
          } @else if (i.isErroFilhos) {
          <app-alert-card type="error" icon="cloud_off">
            Não foi possível carregar as variações deste agrupador.
            <div alertActions>
              <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel" (click)="recarregarVariacoes(i)">
                <mat-icon class="material-symbols-outlined">refresh</mat-icon>Tentar novamente
              </button>
            </div>
          </app-alert-card>
          } @else {
          <div class="associacao-variacao-lista">
            @for (filho of i.filhosVariacao; track filho.idProduto) {
            <button type="button" class="associacao-variacao-opcao" [class.active]="isVariacaoSelecionada(i, filho)"
              [disabled]="data.isSomenteLeitura || i.isAtualizandoCadastro" (click)="escolherVariacao(i, filho)">
              {{ filho.descricao }}
              @if (filho.codigoSku) { <span class="associacao-variacao-sku">{{ filho.codigoSku }}</span> }
            </button>
            } @empty {
            <span class="associacao-coluna-meta">Nenhuma variação cadastrada para este agrupador.</span>
            }
          </div>
          }
        </div>
        }

        @if (isFabricado(i)) {
        <app-alert-card type="warning">
          <b>Produto fabricado</b> recebendo entrada por compra - confira se é mesmo uma aquisição de terceiros antes de confirmar.
        </app-alert-card>
        }

        @if (isUnidadeDiferente(i)) {
        <app-content-card [tone]="i.isFatorConfirmado ? 'success' : 'warning'" icon="swap_horiz" title="Conversão de unidade">
          <div class="associacao-conversao-texto">
            A NF veio em <b>{{ i.item.unidadeComercial }}</b> e o estoque controla em <b>{{ i.produto?.unidade || 'unidade não definida no produto' }}</b>.
          </div>
          <div class="associacao-numero associacao-conversao-calculo">
            {{ i.item.quantidadeComercial | abnt: 'quantidade' }} {{ i.item.unidadeComercial }} × fator {{ i.fator ?? '-' }} →
            <b>{{ quantidadeEstoque(i) | abnt: 'quantidade' }} {{ i.produto?.unidade }}</b> no estoque
          </div>
          <div contentCardActions class="associacao-conversao-acoes">
            <mat-form-field appearance="outline" class="associacao-conversao-fator" subscriptSizing="dynamic">
              <mat-label>Fator de conversão</mat-label>
              <input matInput type="text" inputmode="numeric" [currencyMask]="fatorMask" [ngModel]="i.fator"
                (ngModelChange)="alterarFator(i, $event)" [disabled]="data.isSomenteLeitura || i.isFatorConfirmado" />
            </mat-form-field>
            @if (i.isFatorConfirmado) {
            <span class="status-badge badge-verde"><mat-icon class="material-symbols-outlined">check</mat-icon>
              {{ i.isFatorDoCadastro ? 'Fator do cadastro' : 'Fator aceito' }}
            </span>
            } @else if (!data.isSomenteLeitura) {
            <button mat-flat-button type="button" class="btn-primary associacao-botao-painel" (click)="confirmarFator(i)">Confirmar fator</button>
            }
          </div>
          <div contentCardFooter class="associacao-conversao-historico">
            <mat-icon class="material-symbols-outlined">history</mat-icon><span>{{ textoHistoricoFator(i) }}</span>
            @if (i.isFatorDoCadastro && !data.isSomenteLeitura) {
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel btn-spinner" [disabled]="i.isAtualizandoCadastro"
              [class.btn-loading]="i.operacaoCadastro === operacaoCadastroEnum.ConversaoSalva"
              aria-label="Limpar conversão salva" matTooltip="Remover o fator salvo no cadastro do fornecedor" (click)="limparConversaoSalva(i)">
              <mat-icon class="material-symbols-outlined">layers_clear</mat-icon>
              Limpar conversão salva
              @if (i.operacaoCadastro === operacaoCadastroEnum.ConversaoSalva) { <mat-spinner diameter="18"></mat-spinner> }
            </button>
            }
            @if (i.isFatorConfirmado && !data.isSomenteLeitura) {
            <button mat-stroked-button type="button" class="btn-secondary associacao-botao-painel" (click)="ajustarFator(i)">Ajustar</button>
            }
          </div>
        </app-content-card>
        }

        @if (i.produto && tipoControle(i) !== null) {
        <app-estoque-lote-serie-inline
          [tipo]="tipoControle(i) === tipoControleEnum.Serie ? 'serie' : 'lote'"
          modo="criar"
          [quantidadeAlvo]="quantidadeEstoque(i)"
          [contexto]="i.produto.descricao"
          [idProduto]="i.produto.idProduto"
          [isFracionada]="i.produto.isUnidadeMedidaFracionada"
          [isSomenteLeitura]="data.isSomenteLeitura"
          [itens]="tipoControle(i) === tipoControleEnum.Serie ? i.itensSerie : i.itensLote"
          [(aberto)]="i.isLoteSerieAberto"
          (itensChange)="alterarLoteSerie(i, $any($event))">
        </app-estoque-lote-serie-inline>
        }
      </div>
      }

      @if (i.estado === estadoEnum.Associado && isLoteSeriePendente(i)) {
      <div class="associacao-card-pendencia">
        <mat-icon class="material-symbols-outlined">error</mat-icon>
        {{ tipoControle(i) === tipoControleEnum.Serie ? 'Item associado - informe os números de série' : 'Item associado - aloque toda a quantidade em lotes' }}
      </div>
      }
      }
    </div>
    }
  </div>
  }
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer associacao-rodape">
  @if (exibirAcessarNota) {
  <button mat-stroked-button type="button" class="btn-secondary" (click)="acessarNota()">
    <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
    Acessar a nota
  </button>
  }
  <div class="associacao-progresso">
    <span class="associacao-progresso-texto">
      {{ quantidadeResolvidos }} de {{ quantidadeTotal }} {{ quantidadeTotal === 1 ? 'associado' : 'associados' }}
    </span>
    <div class="associacao-progresso-trilho">
      <div class="associacao-progresso-barra" [style.width.%]="percentualResolvidos"></div>
    </div>
  </div>
  @if (aprendizadoPendente) {
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fecharComAprendizadoPendente()" [disabled]="isRepetindoAprendizado">Fechar</button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isRepetindoAprendizado"
    aria-label="Registrar códigos do fornecedor novamente" (click)="repetirAprendizado()" [disabled]="isRepetindoAprendizado">
    Registrar códigos novamente
    @if (isRepetindoAprendizado) { <mat-spinner diameter="18"></mat-spinner> }
  </button>
  } @else {
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()" [disabled]="isGravando">Cancelar</button>
  @if (!data.isSomenteLeitura) {
  <button mat-stroked-button type="button" class="btn-secondary btn-spinner" [class.btn-loading]="isSalvando" aria-label="Salvar associação"
    (click)="salvar()" [disabled]="isGravando || isLoading || isErroCarga || isErroCargaProdutos || isAtualizandoCadastroItem">
    Salvar
    @if (isSalvando) { <mat-spinner diameter="18"></mat-spinner> }
  </button>
  @if (isTodosAssociados) {
  <!-- Kanban e Suprimentos usam o mesmo texto: no Kanban, o vínculo abre em outro modal depois de concluir (decisão 2026-10-01). -->
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isConcluindo"
    aria-label="Concluir associação" (click)="concluir()"
    [disabled]="isGravando || isLoading || isErroCarga || isErroCargaProdutos || isAtualizandoCadastroItem">
    Concluir associação
    @if (isConcluindo) { <mat-spinner diameter="18"></mat-spinner> }
  </button>
  } @else {
  <button mat-flat-button type="button" class="btn-primary" (click)="confirmarTodos()" [disabled]="isGravando || isLoading || isErroCarga">
    Confirmar todos
  </button>
  }
  }
  }
</mat-dialog-actions>
